import React from 'react';
import { Discount } from '../../../../types/discounts';
import { WithTranslation, withTranslation } from 'react-i18next';
import styled from 'styled-components/macro';
import { DateTime } from '../../../../components/Formatters';

interface PeriodProps extends WithTranslation {
    discount: Discount;
}

const Period = (
    {
        discount,
        t,
    }: PeriodProps
) => (<PeriodContainer>
    <Header>{t('customers.customer.discounts.period')}</Header>
    <Value>
        <DateTime isoString={discount.requirement.purchase_from} /> - <DateTime isoString={discount.requirement.purchase_to} />
    </Value>
</PeriodContainer>);

export default withTranslation()(Period);

const PeriodContainer = styled.div`
    font-size: 14px;
`;

const Header = styled.span`
    font-weight: 700;
    color: #46535E;
`;

const Value = styled.span`
    margin-left: 8px;
`;



